var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { FieldWrapper, FlexBox, InputText, } from '@dixa/lib-shared-habla';
import { useCallback, useState } from 'react';
import * as React from 'react';
import { durationConverter } from 'utils/duration';
import styles from './duration.module.scss';
var TimeUnit;
(function (TimeUnit) {
    TimeUnit["Days"] = "days";
    TimeUnit["Hours"] = "hours";
    TimeUnit["Minutes"] = "minutes";
    TimeUnit["Seconds"] = "seconds";
})(TimeUnit || (TimeUnit = {}));
export function Duration(_a) {
    var { className, duration, withHours, withDays, onChange } = _a, rest = __rest(_a, ["className", "duration", "withHours", "withDays", "onChange"]);
    const [state, setState] = useState(durationConverter.splitTimeUnits(duration || 0, true));
    const handleTimeChange = useCallback((name) => ({ target: { value } }) => {
        setState((currentState) => (Object.assign(Object.assign({}, currentState), { [name]: isNaN(parseInt(value)) ? undefined : parseInt(value) })));
    }, []);
    const handleInternalValueChange = useCallback(() => {
        setState((currentState) => {
            const { days = 0, hours = 0, minutes = 0, seconds = 0 } = currentState;
            const durationInSeconds = durationConverter.combineTimeUnits(days, hours, minutes, seconds);
            onChange(durationInSeconds);
            if (withHours) {
                return durationConverter.splitTimeUnits(durationInSeconds, withDays);
            }
            return durationConverter.seconds.toMinutesAndSeconds(durationInSeconds);
        });
    }, [onChange, withDays, withHours]);
    const renderTimeInput = (name) => {
        var _a;
        const unit = `${name.charAt(0).toUpperCase()}${name.slice(1)}`;
        return (_jsx(InputText, { className: styles.field, min: "0", step: "1", name: name, onChange: handleTimeChange(name), onBlur: handleInternalValueChange, suffix: unit, type: "number", value: ((_a = state[TimeUnit[unit]]) === null || _a === void 0 ? void 0 : _a.toString()) || '' }));
    };
    return (_jsx(FieldWrapper, Object.assign({ className: className }, rest, { children: _jsxs(FlexBox, { children: [withDays && withHours && renderTimeInput(TimeUnit.Days), withHours && renderTimeInput(TimeUnit.Hours), renderTimeInput(TimeUnit.Minutes), renderTimeInput(TimeUnit.Seconds)] }) })));
}
